export default "__VITE_ASSET__BOh2TSx$__"